<template>
  <div class="nanjing-data-board" :style="{minHeight:nanjingDataBoardStyle.height}">
    <!-- 头部 -->
    <div class="title-wrap">
      <div class="title">
        <span>{{ schoolInfo.schoolName }}未来教室课堂数据分析</span>
      </div>
      <div class="date-time">
        <span>{{ times }}</span>
      </div>
    </div>
    <!-- 内容 -->
    <div class="container" >
      <div class="left">
        <div class="top">
          <div class="left">
            <TeacherActivityTrend :activity-trend-list="userActivityTrendList" :zoom="zoom"/>
          </div>
          <div class="right">
            <TeachingBehaviorAnalysis :teaching-behavior-data="teachingBehaviorData" :zoom="zoom"/>
          </div>
        </div>
        <div class="bottom">
          <TodayClass :grade-list="gradeList" :subject-list="subjectList" :school-id="schoolId"
                      @handle-classroom-click="parentClassClick" :zoom="zoom"/>
        </div>
      </div>
      <div class="right">
        <ClassroomReality ref="classroomRealityRef"/>
      </div>
    </div>
  </div>
</template>

<script>
import TeacherActivityTrend from "./modules/teacherActivityTrend.vue";
import TeachingBehaviorAnalysis from "./modules/teachingBehaviorAnalysis.vue";
import TodayClass from "./modules/todayClass.vue";
import ClassroomReality from "./modules/classroomReality.vue"
import {findSchoolInfoById} from "../../service/api";
import {
  getGradeListBySchoolIdApi, getScreenBindClassBySchoolIdApi, getSubjectApi,
  getTeachingBehaviorDataApi,
  getUserActivityTrendApi
} from "../../service/bigDataApi";
import DevicePixelRatio from "../../util/DevicePixelRatio";

export default {
  name: "nanjing-data-board",
  components: {TeachingBehaviorAnalysis, TeacherActivityTrend, TodayClass, ClassroomReality},
  computed: {},
  data() {
    return {
      // 屏幕默认高度
      screenHeight: document.body.clientHeight,
      // 页面高度
      nanjingDataBoardStyle: {
        height: "",
      },
      // 内容高度
      containerStyle: {
        height: "",
      },
      //格式化之后的当前时间
      times: '',
      //学校id
      schoolId: this.$route.query.schoolId || this.$route.query.id || this.$route.params.schoolId || this.$route.params.schoolId || this.$route.params.id,
      // 学校基础信息
      schoolInfo: {
        schoolName: ''
      },
      // 用户活跃趋势列表
      userActivityTrendList: [],
      // 近七天教学行为数据
      teachingBehaviorData: {},
      // 年级列表
      gradeList: [],
      // 学科列表
      subjectList: [],
      // 缩放比列
      zoom: 1
    };
  },
  created() {
    this.getTimes()
  },
  // 在Vue实例销毁前，清除我们的定时器
  beforeDestroy() {
    if (this.times) {
      clearInterval(this.getTimesInterval)
    }
  },
  watch: {},
  methods: {
    // 获取时间
    getTimes() {
      setInterval(this.getTimesInterval, 1000)
    },

    // 获取时间间隔
    getTimesInterval: function () {
      let _this = this;
      let date = new Date();
      let year = date.getFullYear(); //获取当前时间的年份
      let month = date.getMonth() + 1; //获取当前时间的月份
      let day = date.getDate(); //获取当前时间的天数
      let hours = date.getHours(); //获取当前时间的小时
      let minutes = date.getMinutes(); //获取当前时间的分数
      let seconds = date.getSeconds(); //获取当前时间的秒数
      let week = date.getDay(); // 星期
      let weekArr = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
      //当小于 10 的是时候，在前面加 0
      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      if (seconds < 10) {
        seconds = "0" + seconds;
      }
      if (month < 10) {
        month = "0" + month;
      }
      if (day < 10) {
        day = "0" + day;
      }
      // 设置默认文字
      let state = ``;
      // 判断当前时间段
      if (hours >= 0 && hours <= 12) {
        state = `上午`;
      } else if (hours > 12 && hours <= 18) {
        state = `下午`;
      } else if (hours > 18 && hours <= 24) {
        state = `晚上`;
      }

      //拼接格式化当前时间
      _this.times = year + "/" + month + "/" + day + "  " + weekArr[week] + "  " + state + hours + ":" + minutes + ":" + seconds;
    },

    // 根据学校id获取学校基础信息
    async findSchoolInfoData() {
      let _this = this;
      // 学校ID，不传是平台的
      let params = {
        schoolId: _this.schoolId === "0" ? "" : _this.schoolId,
      };
      await findSchoolInfoById(params).then((data) => {
        Object.assign(_this.schoolInfo, data)
      })
    },

    // 根据学校id获取用户活跃趋势列表
    async findUserActivityTrendData() {
      let _this = this;
      // 学校ID，不传是平台的
      let params = {
        schoolId: _this.schoolId === "0" ? "" : _this.schoolId
      };
      await getUserActivityTrendApi(params).then((data) => {
        _this.userActivityTrendList = data.reverse();
      }).catch(function (error) {
        _this.$Message.error(error.message);
      })
    },

    // 根据学校id获取教师近七天教学行为数据
    async findTeachingBehaviorData() {
      let _this = this;
      // 学校ID，不传是
      let params = {
        schoolId: _this.schoolId === "0" ? "" : _this.schoolId
      };
      await getTeachingBehaviorDataApi(params).then((data) => {
        _this.teachingBehaviorData = data
      }).catch(function (error) {
        _this.$Message.error(error.message);
      });
    },

    // 获取学校下的年级列表
    async findGradeList() {
      let _this = this;
      // 学校ID，不传是平台的
      let params = {
        schoolId: _this.schoolId === "0" ? "" : _this.schoolId
      };
      await getGradeListBySchoolIdApi(params).then((data) => {
        if (data.length > 0) {
          _this.gradeList = data.map((item) => {
            return {
              gradeId: item.year + ',' + item.phase,
              gradeName: item.gradeName,
            }
          });
        } else {
          _this.gradeList = [];
        }
      }).catch(function (error) {
        _this.$Message.error(error.message);
      });
    },

    // 获取学校下的学科列表
    async findSubjectList() {
      let _this = this;
      // 学校ID，不传是平台的
      let params = {
        schoolId: _this.schoolId === "0" ? "" : _this.schoolId
      }
      await getSubjectApi(params).then((data) => {
        _this.subjectList = data;
      }).catch(function (error) {
        _this.$Message.error(error.message);
      })
    },

    // 父组件今日课堂点击事件
    parentClassClick(data) {
      this.$refs.classroomRealityRef.findRealityData(data)
    },

    // 适配缩放比列
    customZoom() {
      this.zoom = window.devicePixelRatio
    }
  },
  mounted() {
    const _this = this;
    this.$nextTick(() => {
      let windowHeight = window.innerHeight;
      // if (windowHeight < 900) {
      //   windowHeight = 938;
      //   document.getElementsByTagName("body")[0].className = "active";
      // }
      _this.screenHeight = windowHeight;
      // 页面高度
      _this.nanjingDataBoardStyle.height = windowHeight + "px";
      console.log("屏幕高度：", windowHeight)
      // 头部标题高度
      let titleHeight = 72;
      // 内容高度
      _this.containerStyle.height = windowHeight - titleHeight + "px";

      this.findSchoolInfoData()
      this.findUserActivityTrendData()
      this.findTeachingBehaviorData()
      this.findGradeList()
      this.findSubjectList()
    });

    // 注：window.onresize只能在项目内触发1次
    window.onresize = function windowResize() {
      // 通过捕获系统的onresize事件触发我们需要执行的事件
      let windowHeight = document.body.clientHeight;
      if (windowHeight < 900) {
        windowHeight = 938;
        document.getElementsByTagName("body")[0].className = "active";
      }
      _this.screenHeight = windowHeight;
      // 页面高度
      _this.nanjingDataBoardStyle.height = windowHeight + "px";

      // 头部标题高度
      let titleHeight = 72;
      // 内容高度
      _this.containerStyle.height = windowHeight - titleHeight + "px";
    };

    new DevicePixelRatio().init();
    this.customZoom()
  },
};

</script>

<style scoped lang="scss">
@import "../../style/databoard";
@import "../../style/detailPage";

@font-face {
  font-family: MaravaleExpanded;
  src: url("../../assets/fonts/digifaw.ttf"); //字体路径
}

.nanjing-data-board {
  background-color: #000734;
  background-image: url("../../assets/images/nanjingdataboard/big-bg.png");
  background-size: cover;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  overflow-y: auto;

  .title-wrap {
    background-image: url("../../assets/images/nanjingdataboard/head-bg.png");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: top;
    //height: 72px;
    height: 8%;
    position: relative;


    .title {
      //margin-top: 30px;
      margin-top: unset;
      box-sizing: border-box;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      //height: 72px !important;
      //line-height: 72px;
      //background: linear-gradient(0deg, rgba(77, 190, 255, 0.62) 0%, rgba(77, 190, 255, 0) 100%);
      //-webkit-background-clip: text;
      //-webkit-text-fill-color: transparent;
    }
  }

  .container {
    position: relative;
    width: 100%;
    height: 92%;
    box-sizing: border-box;

    .left {
      position: relative;
      width: 80%;
      height: 100%;
      padding: 10px;
      box-sizing: border-box;
      float: left;

      .top {
        position: relative;
        width: 100%;
        height: 50%;

        box-sizing: border-box;
        padding-bottom: 5px;

        .left {
          position: relative;
          width: 60%;
          height: 100%;
          box-sizing: border-box;
          float: left;
        }

        .right {
          position: relative;
          width: 40%;
          height: 100%;
          box-sizing: border-box;
          float: left;
        }
      }

      .bottom {
        position: relative;
        width: 100%;
        height: 50%;
        box-sizing: border-box;
        padding-top: 5px;
      }
    }

    .right {
      position: relative;
      width: 20%;
      height: 100%;
      padding: 10px;
      box-sizing: border-box;
      float: left;
    }
  }
}
</style>